import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

interface StatCardProps {
  label: string;
  value: string;
  helper?: string;
  icon?: ReactNode;
  accent?: string;
}

const StatCard = ({ label, value, helper, icon, accent }: StatCardProps) => (
  <Card
    sx={{
      height: "100%",
      border: "1px solid rgba(13, 27, 42, 0.06)",
      background: "rgba(255, 255, 255, 0.95)",
    }}
  >
    <CardContent>
      <Stack direction="row" spacing={2} alignItems="center">
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: accent ? `${accent}22` : "rgba(11, 142, 139, 0.15)",
            color: accent || "primary.main",
          }}
        >
          {icon}
        </Box>
        <Box>
          <Typography variant="subtitle2" color="text.secondary">
            {label}
          </Typography>
          <Typography
            variant="h5"
            sx={{ fontFamily: "Sora, DM Sans, sans-serif" }}
          >
            {value}
          </Typography>
          {helper ? (
            <Typography variant="caption" color="text.secondary">
              {helper}
            </Typography>
          ) : null}
        </Box>
      </Stack>
    </CardContent>
  </Card>
);

export default StatCard;
